import React from 'react';
import LegalDoc from './LegalDoc';
import content from './DATA_PROCESSING_AGREEMENT.md?raw';

const DataProcessingAgreement = () => <LegalDoc content={content} />;

export default DataProcessingAgreement;
